import { render, staticRenderFns } from "./ClassAndRacePanel.vue?vue&type=template&id=2ee81e9c"
import script from "./ClassAndRacePanel.vue?vue&type=script&lang=js"
export * from "./ClassAndRacePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports